const primary = ['#0089ff', '#00294d'];
const secondary = ['#fc6e51', '#fec333', '#906ed3', '#00c8d7', '#2ecc71'];
const neutral = ['#335471', '#5c768d', '#7e94a7', '#d0d8de', '#e1e0e6', '#f7f9fb'];
const redColor = ['#bb3420', '#e3472d', '#fc6e51', '#fdcbc0', '#f9e9e8'];
const orangeColor = ['#fa6918', '#fc991b', '#fec333', '#ffe9b4', '#fff7e1'];
const purpleColor = ['#361da7', '#5d30bd', '#906ed3', '#cfc1eb', '#ede7f6'];
const cyanColor = ['#00858d', '#00aebf', '#00c8d7', '#aaecef', '#ddf8f9'];
const greenColor = ['#006e1e', '#009f3e', '#2ecc71', '#c0edcd', '#e5f8eb'];
const blueColor = ['#002fa1', '#1463d8', '#0089ff', '#badfff', '#e3f2ff'];
const $white = '#fff';
const $black = '#000';
const $whitesmokeColor = '#f5f5f5';

const borderColor = neutral[4];
const bgColor = {
  base: neutral[5],
  dark: '#253858',
  grey: neutral[2],
  error: secondary[0],
  warning: secondary[1],
  info: secondary[3],
  success: secondary[4],
  disabled: neutral[4],
  primaryLight: 'rgba(0, 137, 255, 0.08)',//`rgba(${primary[0]}, 0.08)`,
  // error: '#f9e9e8',
  // success: '#e5f8eb',
  // warning: '#fff7e1',
  // info: '#e3f2ff',
  // light: '#fff',
};

const colors = {
  primaryColor: primary[1],
  secondaryColor: neutral[0],
  tertiaryColor: neutral[1],

  heading: primary[1],
  // secondaryHeading: neutral[0],
  // tertiaryHeading: neutral[1],
  // primarySubHeading: neutral[1],
  subHeading: neutral[2],
  label: neutral[2],
  disabled: neutral[4],
  dark: $black,
  white: $white,
  black: $black,
  boxShadow: 'rgba(23, 23, 77, 0.1)',

  error: secondary[0],
  warning: secondary[1],
  info: secondary[3],
  success: secondary[4],

  primaryBlue: primary[0],
  // info:
  // light:

  redColor: redColor,
  orangeColor: orangeColor,
  purpleColor: purpleColor,
  cyanColor: cyanColor,
  greenColor: greenColor,
  blueColor: blueColor,
  whitesmokeColor: $whitesmokeColor,
};

export {
  colors,
  bgColor,
  borderColor,
};